<ng-container *transloco="let t; read: 'user'">
  <div class="rounded-lg">

      <div  id="addProviderDialog" class="flex justify-between border-b">
          <h1 class="text-[25px] font-bold">{{ t('manageEnrollment.sharedProviders.addProvider') }}</h1>
          <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
      </div>
      <div id="add-child-shared-provider" mat-dialog-content>
          <form class="grid grid-cols-2 gap-x-10 p-3" [formGroup]="childSharedProviderForm">
              <div class="col-span-1 items-center w-[100%]">
                  <drdp-select-providers (provider)="handleTeacher($event)"
                                          [initialProviderId]="teacherId.value"
                                          [isValid]="!teacherId.touched || teacherId.valid"
                                          [required]="true">

                  </drdp-select-providers>
              </div>

              <div class="col-span-1 items-center w-[100%]">
                  <label class="font-normal required" for="name">{{ t('manageEnrollment.sharedProviders.providerName') }}</label>
                  <mat-form-field class="bg-white" appearance="fill">
                      <input [placeholder]="t('manageEnrollment.sharedProviders.providerName')" matInput type="text" readonly="true" formControlName="name"
                          maxlength="200">
                  </mat-form-field>
              </div>
          </form>
      </div>
      <div mat-dialog-actions class="flex justify-end align-bottom">
          <button mat-button mat-dialog-close>{{ t('manageEnrollment.viewChild.actions.cancel') }}</button>
          <drdp-btn type="submit" mat-button [disabled]="childSharedProviderForm.invalid" cdkFocusInitial
              (click)="onSubmit()">{{ t('manageEnrollment.sharedProviders.addProvider') }}</drdp-btn>
      </div>

  </div>
</ng-container>